<ng-container *ngIf="formGroup" [formGroup]="formGroup" class="">
  <div class="">

    <div class="row">
      <div class="col-md-12 p-4 pt-2 pb-2">
        <div class="mb-2 border-bottom row">
          <div class="col-md-10">
            <div class="mogo-header-2 text-start ">Voyage Information</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row p-2">
      <div class="col-6">
        <div class="row pb-2">
          <label class="col-3 mt-2 text-end mogo-bold">Sea port:</label>
          <div class="col-9">
            <ng-select id="SeaportDropdown" formControlName="originPort" bindLabel="display" [items]="availableSeaPorts"
              placeholder="Select port">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="text-md-start">
                  {{ item.display }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="row pb-2" *ngIf="showIsInlandPortOption()">
          <label class="col-3 mt-2 text-end mogo-bold">Use Inland Port:</label>
          <div class="col-1 mt-1">
            <input type="checkbox" formControlName="isUsingInlandPort" />

          </div>
        </div>

        <div class="row pb-2" *ngIf="showLandPort()">
          <label class="col-3 mt-2 text-end mogo-bold">Inland Port:</label>
          <div class="col-9">
            <ng-select [items]="onwardPorts" bindLabel="name" formControlName="onwardPort">
            </ng-select>
          </div>
        </div>

        <div class="row pb-2" *ngIf="vesselVisits">
          <label class="col-3 mt-2 text-end mogo-bold">{{getVesselType()}}:</label>
          <div class="col-9">
            <ng-select id="VesselDropdown" [items]="vesselVisits" bindLabel="label"
              [placeholder]="'Select the '+ getVesselType()" formControlName="vessel" [addTag]="addVesselNameTag"
              [selectOnTab]="true" [typeahead]="vesselInput" [loading]="vesselLoading">
              <ng-template ng-typetosearch-tmp>
                <div class="ng-option disabled">
                  Select the {{getVesselType()}}
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
              <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  Fetching data for "{{searchTerm}}"
                </div>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <div [hidden]="!(item)">{{item.vesselName}} - {{formatVesselDate(item)}}</div>
              </ng-template>
              <ng-template ng-tag-tmp let-search="searchTerm">
                <div class="text-center"><button class="btn btn-primary btn-sm">Create</button></div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="text-md-start">
                  {{ item.label }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="row pb-2" *ngIf="formGroup.get('fromEtaEtdDate') !== null">
          <label class="col-3 mt-2 text-end mogo-bold">
            <span *ngIf="isSeaJob()">Vessel </span>
            <span *ngIf="isRailJob()">Train </span>
            - {{ getDirectionalEstimationString() }} <small>(Leave blank if vessel is TBC)</small>:</label>
          <div class="col-9">
            <app-custom-date-range-picker id="VesselEtaDate" *ngIf="isSeaJob()"
              [formControl]="getFormPartial('fromEtaEtdDate')" (change)="onVesselEtaEtdDateChange($event)"
              placeholder="Enter Vessel {{ getDirectionalEstimationString() }}" style="margin-bottom: 0px;">
            </app-custom-date-range-picker>

            <app-custom-date-range-picker *ngIf="!isSeaJob()" [formControl]="getFormPartial('fromEtaEtdDate')"
              (change)="onVesselEtaEtdDateChange($event)"
              placeholder="Enter Train {{ getDirectionalEstimationString() }}" style="margin-bottom: 0px;">
            </app-custom-date-range-picker>

            <small
              *ngIf="formGroup.get('fromEtaEtdDate')!.invalid && (formGroup.get('fromEtaEtdDate')!.dirty || formGroup.get('fromEtaEtdDate')!.touched)">
              <div *ngIf="formGroup.get('fromEtaEtdDate')!.hasError('dateNotLess')" class="text-danger">
                The ETA date of the Arriving leg must be on or after the ETD date of the Departing leg.
              </div>
            </small>
          </div>
        </div>

        <div class="row pb-2" *ngIf="formGroup.get('fullRequestedDeliveryDate') !== null">
          <label class="col-3 mt-2 text-end mogo-bold">Full Requested Delivery Date:</label>
          <div class="col-9">
            <app-custom-date-range-picker id="RequiredDeliveryDate"
              [formControl]="getFormPartial('fullRequestedDeliveryDate')" placeholder="Select date"
              [hideClearButton]="true" (change)="onFullRequestedDeliveryDateChange($event)">
            </app-custom-date-range-picker>

            <small class="text-start"
              *ngIf="formGroup.get('fullRequestedDeliveryDate')!.invalid && (formGroup.get('fullRequestedDeliveryDate')!.dirty || formGroup.get('fullRequestedDeliveryDate')!.touched)">
              <div
                *ngIf="(isInboundJob() || isArrivingLeg) && formGroup.get('fullRequestedDeliveryDate')!.hasError('dateNotLess')"
                class="text-danger">The full requested delivery date must be on or after Vessel ETA</div>
              <div
                *ngIf="(!isInboundJob() || !isArrivingLeg) && formGroup.get('fullRequestedDeliveryDate')!.hasError('dateNotGreater')"
                class="text-danger">The full requested delivery date must be on or before Vessel ETD</div>
              <div
                *ngIf="(!isInboundJob() && !isArrivingLeg) && formGroup.get('fullRequestedDeliveryDate')!.hasError('dateNotLess')"
                class="text-danger">The full requested delivery date must be on or before MT Requested Delivery Date
              </div>
            </small>
          </div>
        </div>

        <div class="row pb-2" *ngIf="formGroup.get('receivalCommenceDate') !== null && !isInboundJob()">
          <label class="col-3 mt-2 text-end mogo-bold">Commence Date</label>
          <div class="col-9">
            <app-custom-date-range-picker [formControl]="getFormPartial('receivalCommenceDate')"
              placeholder="Select date" [hideClearButton]="true" (change)="onReceivalCommenceDateChange($event)">
            </app-custom-date-range-picker>

            <small class="text-start"
              *ngIf="formGroup.get('receivalCommenceDate')!.invalid && (formGroup.get('receivalCommenceDate')!.dirty || formGroup.get('receivalCommenceDate')!.touched)">
              <div *ngIf="formGroup.get('receivalCommenceDate')!.hasError('dateNotGreater')" class="text-danger">
                The receival commence date must be before receival cutoff date
              </div>
            </small>
          </div>
        </div>

        <div class="row pb-2" *ngIf="formGroup.get('receivalCutoffDate') !== null && !isInboundJob()">
          <label class="col-3 mt-2 text-end mogo-bold">Cutoff Date</label>
          <div class="col-9">
            <app-custom-date-range-picker [formControl]="getFormPartial('receivalCutoffDate')" placeholder="Select date"
              [hideClearButton]="true" (change)="onReceivalCutoffDateChange($event)">
            </app-custom-date-range-picker>
            <small class="text-start"
              *ngIf="formGroup.get('receivalCutoffDate')!.invalid && (formGroup.get('receivalCutoffDate')!.dirty || formGroup.get('receivalCutoffDate')!.touched)">
              <div *ngIf="formGroup.get('receivalCutoffDate')!.hasError('dateNotGreater')" class="text-danger">
                The receival cutoff date must be before Vessel ETD
              </div>
              <div *ngIf="formGroup.get('receivalCutoffDate')!.hasError('dateNotLess')" class="text-danger">
                The receival cutoff date must be after receival commence date
              </div>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>